<ng-container *ngIf="vendor$ | async; else loading">
  @if (userHasRolesSet()) {
    <div class="site-container">
      <app-main-top-navigation
        [topNavItems]="topNavItems"
        [sortedSideNavItems]="sortedSideNavItems"
        [profileDropdownItems]="profileDropdownItems"
        [names]="userNames$ | async"
        [companyName]="companyName$ | async"
        (signOut)="logout()"
      />
      <app-main-side-navigation [canCreateProjects]="canCreateProject" />
      <main
        class="container-col"
        [ngClass]="{ closed: this.menuIsClosed }"
      >
        <router-outlet></router-outlet>
      </main>
    </div>
  } @else {
    <div class="login-container registration">
      <div class="sustainment-logo"></div>
      <div class="widget-container">
        <div class="registration-section-container">
          @if (userRoles() && userRoles().length > 0) {
            <app-registration-company-type
              *ngIf="currentStep === steps.CompanyTypeRegistration"
              [roles]="userRoles()"
              (enableContinue)="rolesSelected = $event"
              (roleSelected)="roles = $event"
            ></app-registration-company-type>
            <app-user-problems
              [problems]="selectedProblems()"
              (enableContinue)="problemSelected = $event"
              (problemSelected)="problems = $event"
              *ngIf="currentStep === steps.UserProblems"
            >
            </app-user-problems>

            <div class="registration-section-footer margin-top-32">
              <div>
                <a
                  href="javascript:void(0)"
                  *ngIf="currentStep === steps.UserProblems"
                  (click)="goBack()"
                >
                  Back
                </a>
              </div>
              <div class="col-right">
                <s-button
                  type="primary"
                  [disabled]="!rolesSelected"
                  (click)="
                    currentStep === steps.UserProblems
                      ? saveRoles()
                      : goToProblemSelection()
                  "
                  [label]="savingRoles ? 'Saving' : 'Continue'"
                  [icon]="savingRoles ? 'pi pi-spin pi-spinner' : ''"
                ></s-button>
              </div>
            </div>
          } @else {
            <div class="spinner">
              <i class="pi pi-spin pi-spinner"></i>
            </div>
          }
        </div>
      </div>
    </div>
  }
  <footer>
    <div class="footerContainer">
      <span>powered by</span>
      <div>
        <img
          src="/assets/sustainment-icons/sustain-icon-white.png"
          width="30px"
          loading="lazy"
        />
        <span>SUSTAINMENT</span>
      </div>
    </div>
  </footer>
</ng-container>

<ng-template #loading>
  <div class="load">
    <img
      class="loading-logo"
      src="/assets/sustainment-icons/sustain-icon-white.png"
    />
  </div>
</ng-template>
